import React from 'react';

const Blogs = () => {
    return (
        <section>
            <div className="container">
                <div className="d-flex w-100 vh-100 align-items-center justify-content-center">
                    <h3>Coming soon...</h3>
                </div>
            </div>
        </section>
    );
};

export default Blogs;